// extracted by mini-css-extract-plugin
export var similarityVisual = "Hero-module--similarity-visual--3Vr6K";
export var content = "Hero-module--content--3aVxi";
export var fadeInUp = "Hero-module--fade-in-up--3qyfi";
export var whiteText = "Hero-module--whiteText--2n33e";
export var background = "Hero-module--background--D5FzT";
export var image = "Hero-module--image--2_41c";
export var gradient = "Hero-module--gradient--3Yzti";